// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__15JcD","grow0":"Button_grow0__1kYKj","grow1":"Button_grow1__3h9UV"};